export default "__VITE_ASSET__DKkRI1vM__"